<template lang="pug">
.v-legal-info.legal-info(v-if="info")
	.legal-info__text(v-if="info.text" v-html="info.text")
	.legal-info__links(v-if="info.links && info.links.length")
		template(v-for="(link, index) in info.links" :key="index")
			a.legal-info__link(:href="link.link") {{link.text}}

		a.legal-info__link(href="https://www.newsite.by/") Разработка сайта New IT
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			info: null
		};
	},

	methods: {
		dataSet(data) {
			this.info = data;
		}
	}
}
</script>
